import React from 'react';
import Layout from '@/components/Layout';
import { GlassCard } from '@/components/ui/glass-card';
import { Users, FileText, Image, Calendar, DollarSign, Settings } from 'lucide-react';

export default function AdminPanel() {
  return (
    <Layout>
      <section className="py-20 bg-gradient-to-r from-blue-900 to-blue-950 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-4xl font-bold mb-2">Admin Panel</h1>
          <p className="text-blue-100">Complete school management system</p>
        </div>
      </section>
      <section className="py-12 bg-slate-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-3 lg:grid-cols-6 gap-6 mb-12">
            {[
              { icon: Users, label: 'Students', value: '1100+', color: 'bg-blue-100 text-blue-700' },
              { icon: Users, label: 'Teachers', value: '50', color: 'bg-green-100 text-green-700' },
              { icon: FileText, label: 'News', value: '25', color: 'bg-purple-100 text-purple-700' },
              { icon: Image, label: 'Gallery', value: '150', color: 'bg-pink-100 text-pink-700' },
              { icon: Calendar, label: 'Events', value: '12', color: 'bg-amber-100 text-amber-700' },
              { icon: DollarSign, label: 'Fees', value: '₹50L', color: 'bg-emerald-100 text-emerald-700' }
            ].map((stat, i) => (
              <GlassCard key={i} className="text-center">
                <div className={`w-12 h-12 ${stat.color} rounded-xl flex items-center justify-center mx-auto mb-3`}>
                  <stat.icon className="w-6 h-6" />
                </div>
                <h3 className="text-2xl font-bold text-blue-900 mb-1">{stat.value}</h3>
                <p className="text-xs text-slate-600 font-medium">{stat.label}</p>
              </GlassCard>
            ))}
          </div>
          <h2 className="text-2xl font-bold text-blue-900 mb-6">Management</h2>
          <div className="grid md:grid-cols-3 gap-6">
            {['Manage Students', 'Manage Teachers', 'Post News', 'Upload Gallery', 'Manage Events', 'Fee Management', 'Send Notifications', 'View Reports', 'System Settings'].map((action, i) => (
              <GlassCard key={i} className="hover:shadow-xl transition-shadow cursor-pointer text-center p-6">
                <p className="font-semibold text-blue-900">{action}</p>
              </GlassCard>
            ))}
          </div>
        </div>
      </section>
    </Layout>
  );
}
